import * as React from 'react';
import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../../../../ParticipantsStore';
import UserGroupMembershipsStore from '../../Store';
import { Ready } from '../../Store/Types';
import Content from './Content';
import EmptyGroupsMessage from './EmptyGroupsMessage';
import { userGroupOptions } from './UserGroupOptions';

interface Props {
  participantsStore: ParticipantsStore;
  userGroupMembershipsStore: UserGroupMembershipsStore;
  state: Ready;
}

const New: React.FC<Props> = ({ participantsStore, userGroupMembershipsStore, state }) =>
  userGroupOptions(state)
    .map(() => (
      <Content
        participantsStore={participantsStore}
        userGroupMembershipsStore={userGroupMembershipsStore}
        state={state}
      />
    ))
    .getOrElse(() => <EmptyGroupsMessage />);

export default observer(New);
